import Vue from 'vue';
import FastSync from './fast-sync';
import ApiService from '../services/api.service';

const factories = {
  fastSync: FastSync(ApiService),
};

Vue.prototype.$api = factories;
